function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 29.1963L38 34.1963H74L107 29.1963",
  className: "iconBlueStroke",
  stroke: "#428EE0",
  strokeWidth: 7
});

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 37.0712,
  y1: 32.5885,
  x2: 43.0712,
  y2: 5.54646,
  className: "iconBlueStroke",
  stroke: "#428EE0",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  y1: -3,
  x2: 27.6996,
  y2: -3,
  transform: "matrix(-0.216609 -0.976258 -0.976258 0.216609 72 32.2383)",
  className: "iconBlueStroke",
  stroke: "#428EE0",
  strokeWidth: 6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4025 32.1459L58.6089 93.1039",
  stroke: "#428EE0",
  className: "iconBlueStroke",
  strokeWidth: 6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M76.5975 32.1459L53.3911 93.1039",
  stroke: "#428EE0",
  className: "iconBlueStroke",
  strokeWidth: 6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4 31.9431L27.7221 4H84.2779L108 31.9431L56 93.1957L4 31.9431Z",
  className: "iconWhiteStroke",
  stroke: "white",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 97,
    viewBox: "0 0 112 97",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEyIiBoZWlnaHQ9Ijk3IiB2aWV3Qm94PSIwIDAgMTEyIDk3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBhdGggZD0iTTUgMjkuMTk2M0wzOCAzNC4xOTYzSDc0TDEwNyAyOS4xOTYzIiBjbGFzcz0iaWNvbkJsdWVTdHJva2UiIHN0cm9rZT0iIzQyOEVFMCIgc3Ryb2tlLXdpZHRoPSI3Ii8+DQo8bGluZSB4MT0iMzcuMDcxMiIgeTE9IjMyLjU4ODUiIHgyPSI0My4wNzEyIiB5Mj0iNS41NDY0NiIgY2xhc3M9Imljb25CbHVlU3Ryb2tlIiBzdHJva2U9IiM0MjhFRTAiIHN0cm9rZS13aWR0aD0iNiIvPg0KPGxpbmUgeTE9Ii0zIiB4Mj0iMjcuNjk5NiIgeTI9Ii0zIiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yMTY2MDkgLTAuOTc2MjU4IC0wLjk3NjI1OCAwLjIxNjYwOSA3MiAzMi4yMzgzKSIgY2xhc3M9Imljb25CbHVlU3Ryb2tlIiBzdHJva2U9IiM0MjhFRTAiIHN0cm9rZS13aWR0aD0iNiIvPg0KPHBhdGggZD0iTTM1LjQwMjUgMzIuMTQ1OUw1OC42MDg5IDkzLjEwMzkiIHN0cm9rZT0iIzQyOEVFMCIgY2xhc3M9Imljb25CbHVlU3Ryb2tlIiBzdHJva2Utd2lkdGg9IjYiLz4NCjxwYXRoIGQ9Ik03Ni41OTc1IDMyLjE0NTlMNTMuMzkxMSA5My4xMDM5IiBzdHJva2U9IiM0MjhFRTAiIGNsYXNzPSJpY29uQmx1ZVN0cm9rZSIgc3Ryb2tlLXdpZHRoPSI2Ii8+DQo8cGF0aCBkPSJNNCAzMS45NDMxTDI3LjcyMjEgNEg4NC4yNzc5TDEwOCAzMS45NDMxTDU2IDkzLjE5NTdMNCAzMS45NDMxWiIgY2xhc3M9Imljb25XaGl0ZVN0cm9rZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K";
export { SvgComponent as ReactComponent };